import { gql } from 'graphql-request'

export const GET_ROCKET_GAME = gql`
  query GET_ROCKET_GAME($rocketGameId: Int!) {
    getRocketGame(rocketGameId: $rocketGameId) {
      error
      status
      data {
        id
        name
        description
        level
        quantityContribute
        quantityContributeAcumulate
        imgRocketGame
        createdAt
        updatedAt
      }
    }
  }
`
export const GET_ROCKETS_GAMES = gql`
  query GET_ROCKETS_GAMES(
    $take: Int
    $skip: Int
    $name: String
    $description: String
    $level: Int
    $typeFilterQuantityContribute: TypeFilter
    $quantityContributeInitial: Float
    $quantityContributeFinal: Float
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getRocketsGames(
      take: $take
      skip: $skip
      name: $name
      description: $description
      level: $level
      typeFilterQuantityContribute: $typeFilterQuantityContribute
      quantityContributeInitial: $quantityContributeInitial
      quantityContributeFinal: $quantityContributeFinal
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        name
        description
        level
        quantityContribute
        quantityContributeAcumulate
        imgRocketGame
        createdAt
        updatedAt
        rocketGameDetail {
          createdAt
          description
          giftId
          id
          itemId
          name
          updatedAt
          gift {
            id
            name
            imgGift
            iconGift
          }
          item {
            id
            name
            imgItem
          }
        }
      }
    }
  }
`

export const GET_ROCKET_GAME_FIRST = gql`
  query GET_ROCKET_GAME_FIRST(
    $id: Int
    $name: String
    $description: String
    $level: Int
    $typeFilterQuantityContribute: TypeFilter
    $quantityContributeInitial: Float
    $quantityContributeFinal: Float
    $imgRocketGame: String
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getRocketGameFirst(
      id: $id
      name: $name
      description: $description
      level: $level
      typeFilterQuantityContribute: $typeFilterQuantityContribute
      quantityContributeInitial: $quantityContributeInitial
      quantityContributeFinal: $quantityContributeFinal
      imgRocketGame: $imgRocketGame
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        name
        description
        level
        quantityContribute
        quantityContributeAcumulate
        imgRocketGame
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_ROCKETS_GAMES_SUM = gql`
  query GET_ROCKETS_GAMES_SUM(
    $name: String
    $description: String
    $level: Int
    $typeFilterQuantityContribute: TypeFilter
    $quantityContributeInitial: Float
    $quantityContributeFinal: Float
    $imgRocketGame: String
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
    $fieldsSum: [String]
    $includeName: Boolean
    $includeDescription: Boolean
    $includeLevel: Boolean
    $includeQuantityContribute: Boolean
    $includeImgRocketGame: Boolean
  ) {
    getRocketsGamesSum(
      name: $name
      description: $description
      level: $level
      typeFilterQuantityContribute: $typeFilterQuantityContribute
      quantityContributeInitial: $quantityContributeInitial
      quantityContributeFinal: $quantityContributeFinal
      imgRocketGame: $imgRocketGame
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
      fieldsSum: $fieldsSum
      includeName: $includeName
      includeDescription: $includeDescription
      includeLevel: $includeLevel
      includeQuantityContribute: $includeQuantityContribute
      includeImgRocketGame: $includeImgRocketGame
    ) {
      error
      status
      data {
        name
        description
        level
        quantityContribute
        quantityContributeAcumulate
        imgRocketGame
      }
    }
  }
`

export const GET_ROCKETS_GAMES_SUM_ALL = gql`
  query GET_ROCKETS_GAMES_SUM_ALL(
    $name: String
    $description: String
    $level: Int
    $typeFilterQuantityContribute: TypeFilter
    $quantityContributeInitial: Float
    $quantityContributeFinal: Float
    $imgRocketGame: String
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
    $fieldsSum: [String]
    $fieldsGroupBy: [String]
    $includeName: Boolean
    $includeDescription: Boolean
    $includeLevel: Boolean
    $includeQuantityContribute: Boolean
    $includeImgRocketGame: Boolean
  ) {
    getRocketsGamesSumAll(
      name: $name
      description: $description
      level: $level
      typeFilterQuantityContribute: $typeFilterQuantityContribute
      quantityContributeInitial: $quantityContributeInitial
      quantityContributeFinal: $quantityContributeFinal
      imgRocketGame: $imgRocketGame
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
      fieldsSum: $fieldsSum
      fieldsGroupBy: $fieldsGroupBy
      includeName: $includeName
      includeDescription: $includeDescription
      includeLevel: $includeLevel
      includeQuantityContribute: $includeQuantityContribute
      includeImgRocketGame: $includeImgRocketGame
    ) {
      error
      status
      totalPages
      data {
        name
        description
        level
        quantityContribute
        quantityContributeAcumulate
        imgRocketGame
      }
    }
  }
`
